import $ from 'jquery' /*引入jquery*/
import drawListModel from './drawListModel.js' /*引入 绘制 列表 模块*/
import stat_anjuke from '../common/stat_anjuke'
import util from '../common/util'
import randomString from '../common/getGuid.js';
import { exposureForCardUpdate } from '../common/exposureForCard.js'
import getCookie from '../common/getCookieValue.js';

export default function() {
    /*列表title的label点击事件*/
    $('.list-model')
        .on('click', '.list-title span p', function(event) {
            /*如果点击的label是已经被选中则直接返回, 不执行下面操作*/
            if (
                $(this)
                    .parent()
                    .hasClass('list-title-active')
            ) {
                return
            }
            /*给被点击的label添加list-title-active类名, 移出其他label的相同类名*/
            $(this)
                .parent()
                .addClass('list-title-active')
                .siblings()
                .removeClass('list-title-active')
            labelSwitch($(this))
        })
        .on('click', '.title-item', function(event) {
            /*如果点击的label是已经被选中则直接返回, 不执行下面操作*/
            if ($(this).hasClass('list-title-active')) {
                return
            }
            /*给被点击的label添加list-title-active类名, 移出其他label的相同类名*/
            $(this)
                .addClass('list-title-active')
                .siblings()
                .removeClass('list-title-active')
            labelSwitch($(this))
        })
        .on('click', '.list-item .delIcon', function (event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).parent().remove()
            exposureForCardUpdate()
        })
        .on('click', '.list_demo_a .delIcon', function (event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).parent().remove()
            exposureForCardUpdate()
        })
        .on(
            'click',
            '.list-item[data-adtype="23"], .list-item[data-adtype="24"]',
            function(event) {
                //安居客
                var link = $(this).attr('href'),
                    encryptUrl = $(this).attr('data-encrypturl')
                var isLego = util.getQueryStringByPara(link,'isLego')
                if(isLego !== '1'){
                    event.preventDefault()
                    stat_anjuke({
                        detailURL: link,
                        encryptUrl: encryptUrl,
                        cb: function(uuid) {
                            location.href = link + '&cid=' + uuid
                        }
                    })
                }
            }
        )
    
}

/*列表title的label点击方法*/
function labelSwitch($this) {
    let listIndex = $this.parent().index() + 1
    !getCookie('abtest').includes('tab_hide_ab_A') && $(window).scrollTop(0);
    window.pageFeedParams = {
        pn: 1, // 页码
        page_id: randomString(), // 每次请求的唯一标识
        canFeed: true, // 是否可以请求下一页(是否到底)
        loading: false, // 是否请求中
        feedTest: null // 是否是feed流实验下(9或15条帖子)
    }
    /**
     * 调用 绘制列表 模块中 绘制列表内容方法
     * 参数1: 点击label的cateid, 职位名称id;
     * 参数2: 点击label的catename, 职位名称name;
     * 参数3: 点击label的num, 请求的列表条数;
     */
    drawListModel.list_content(
        $this.parents('.list-model').children('.list-content'),
        $this.data('cateid'),
        $this.data('catename'),
        $this.data('num'),
        $this.data('filter'),
        $this.data('liststyle'),
        undefined,
        listIndex,
        $this.data('modeltype'),
        $this.data('tag')
    )
}
